import { getDatabaseContainerType } from '@databases/analytics';
import type { AddFlagProps } from '@databases/flags-types';
import MentionIcon from '@databases/icons/migration/mention';
import React from 'react';

import { type ContentTypesFlagProps } from '@canvas/frame-api-types';

import { BaseMentionBuilder } from './baseMentionBuilder';
import { messages } from './i18n';
import { type MentionBuilder } from './types';
import { getDisplayNameForUsers } from './utils/getDisplayNameForUsers';

export class MentionFlagForMultipleUsers
  extends BaseMentionBuilder
  implements MentionBuilder
{
  shouldShowFlag(): boolean {
    return this.usersWithAccess.length > 2;
  }
  build(): AddFlagProps & ContentTypesFlagProps {
    const { displayNamesCount, displayName, somebodyElse } = getDisplayNameForUsers({
      users: this.usersWithAccess
    });
    const actions = [
      {
        content: this.formatMessage(
          messages['mention-notification.flag-go-to-field-settings-cta']
        ),
        onClick: () => {
          this.showPanel('FieldSettingsPanel', { fieldId: this.fieldId });

          this.analyticsClient.sendMentionNotificationActionEvent({
            contentId: this.contentId,
            databaseContainer: getDatabaseContainerType()
          });
        }
      }
    ];

    return {
      id: `mention-flag-for-multiple-users-${this.contentId}`,
      type: 'custom',
      iconString: 'mention',
      title: this.formatMessage(
        messages[
          'mention-notification.flag-mention-notification-title-three-or-more-users'
        ],
        {
          displayName,
          somebodyElse,
          numOthers: (displayNamesCount - 2).toString()
        }
      ),
      description: !this.isLocked
        ? this.formatMessage(
            messages['mention-notification.flag-mention-notification-description']
          )
        : this.formatMessage(
            messages[
              'mention-notification.flag-mention-notification-description-without-field-settings'
            ]
          ),
      icon: () => <MentionIcon label="" />,
      actions: !this.isLocked ? actions : undefined
    };
  }
}
